module.exports = __webpack_public_path__ + "static/media/website-video-poster.779c1f61.jpg";